module.exports = ".nav {\n    padding: 15px;\n    background-color: #424242;\n    color: #fff;\n}\n\na {\n    text-decoration: underline;\n    color: #FFF;\n}"